import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { categories } from "@/mocks/homeData";

export default function CategoryEntries() {
  return (
    <section id="categories" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <SectionHeading
          eyebrow="分类入口"
          eyebrowIcon="ri-apps-2-line"
          title="按事件类型翻，更快找到你想看的"
          desc="每一类都对应一种翻车方式。数字是当前在库条数，点进去就能看到同一类的全部记录。"
        />

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((item, index) => (
            <Reveal key={item.id} delay={index * 60}>
              <a
                href="#feed"
                className="group flex cursor-pointer items-center gap-4 rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-300 hover:bg-background-50"
              >
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center justify-between gap-2">
                    <h3 className="font-heading text-base font-bold text-foreground-950">{item.name}</h3>
                    <span className="shrink-0 font-mono text-xs text-secondary-600">{item.count}</span>
                  </div>
                  <p className="mt-1 truncate text-xs text-foreground-600">{item.desc}</p>
                </div>
                <span className="flex h-5 w-5 shrink-0 items-center justify-center text-secondary-400 transition-colors group-hover:text-primary-500">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}